import {FuseRouteItemType} from '@fuse/utils/FuseUtils';

import {AUTH_ROLES} from '@/app/auth/authRoles';

import KycPlaidPage from './KycPlaidPage';

const KycRoute: FuseRouteItemType = {
  path: '',
  element: <KycPlaidPage />,
  auth: AUTH_ROLES.parent, // []
};

export default KycRoute;
